<template>
    <div class="datatable-container hero-zero-timeline-table">
        <div class="client-table" id="client-table">
            <table class="table table-dark">
                <thead>
                <tr>
                    <th scope="col">SHA1</th>
                    <th scope="col">Valkyrie Detect Time</th>
                    <th scope="col">VirusTotal Analysis Time</th>
                    <th scope="col">Time Difference</th>
                    <th scope="col">Link</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) in this.selectedDayFiles" :class="{'gray-row-light': index % 2 == 0, 'gray-row-dark': index % 2 != 0}">
                    <td class="sha1">{{item.sha1}}</td>
                    <td class="vt_detect_time">{{item.valkyrie_detection_date | moment}}</td>
                    <td class="vt_analysis_time">{{item.vt_analysis_date | moment}}</td>
                    <td class="time_difference">{{item.time_difference}} hours</td>
                    <td class="links">
                        <div class="valkyrie-container">
                            <a :href="'https://verdict.valkyrie.comodo.com/file/result?s='+item.sha1" target="_blank">
                                <img src="../../assets/valkyrie_logo_head.png" class="vt-icon"/>
                            </a>
                        </div>
                        <div class="radar-container">
                            <a :href="'https://valkyrie.comodo.com/kill/chain/'+item.sha1+'/summary'" target="_blank">
                                <img src="../../assets/radar.png" class="radar-icon"/>
                            </a>
                        </div>

                        <div class="vt-container">
                            <a :href="item.vt_link" style="text-decoration: none; color: white;" target="_blank">
                                <p style="font-weight: bold">VT</p>
                            </a>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    import moment from 'moment-timezone';

    export default {
        name: "HourZeroTimeLineTable",
        props: {
            selectedDayFiles: {
                type: Array | Object,
                required: true
            },
        },
        components: {},
        filters: {
            moment: function (date) {
                return moment(date).format('YYYY-MM-DD hh:mm:ss');
            }
        },
        mounted() {

        }
    }
</script>

<style scoped>
    table {
        display: block;
        max-height: 35vh;
        overflow-y: scroll;
    }

    table::-webkit-scrollbar {
        display: none;
    }
    .datatable-container {
        margin-top: 50px;
        font-family: "Digital-Serial-Bold";
    }

    .table-dark {
        color: white !important;
    }

    thead {
        border-bottom: 3px solid;
        border-color: white;
    }

    th {
        border-right: 3px solid;
        border-color: white;
    }

    .gray-row-light {
        background-color: #424242;
    }

    .gray-row-dark {
        background-color: #535353;
    }

    tbody td:not(:last-child) {
        border-right: 1px solid;
        border-color: white;
    }

    .sha1{
        width: 20%;
    }

    .vt_detect_time{
        width: 25%;
    }

    .vt_analysis_time{
        width: 25%;
    }

    .time_difference{
        width: 10%;
    }

    .vt-icon{
        width: 16px;
        margin-left: 8px;
        margin-top: 2px;
    }

    .radar-icon{
        width: 16px;
        margin-left: 8px;
        margin-top: 7px;
    }

    .links{
        width: 100%;
        display: flex;
        flex-direction: row;
    }

    .valkyrie-container {
        width: 32px;
        height: 32px;
        background: #D77E51;
        border-radius: 50%;
        margin-right: 33px;
    }

    .radar-container{
        width: 32px;
        height: 32px;
        background: #00B3BB;
        border-radius: 50%;
        margin-right: 33px;
    }

    .vt-container{
        width: 32px;
        height: 32px;
        background: #517CB1;
        border-radius: 50%;
    }

    .links img{
        max-width: 100%;
    }

    .links p{
        margin-top: 6px;
        margin-left: 8px;
    }

    .hero-zero-timeline-table {
        font-size: 13px;
    }
</style>



// WEBPACK FOOTER //
// src/components/hour-zero-prevention-timeline/HourZeroTimeLineTable.vue